import ptBR from "./langs/pt-br";

export default {
  "pt-Br": ptBR,
};
